import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=af83d084&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=af83d084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af83d084",
  null
  
)

export default component.exports